import { DefaultFooter } from '@ant-design/pro-layout';
import Settings from '../../../../config/defaultSettings';

export default () => (
  <DefaultFooter copyright={`${new Date().getFullYear()} ${Settings.title}`} links={false} />
);
